module.exports = {
  platform: 'voice',
  name: 'Code',
  node: 'code',
  bg: '#FFFFFF',
  note: '',
  property: {
    code: '// JavaScript code here ...'
  }
}
